module.exports = __webpack_public_path__ + "b4064f1feed24116a2897d2ece25cbcf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-s.png
// module id = 2272
// module chunks = 0